// extracted by mini-css-extract-plugin
export default {"signInModal":"VerifyEmail_signInModal__qrrym","modalIcon":"VerifyEmail_modalIcon__zlR9c","bottomNote":"VerifyEmail_bottomNote__JeIZT"};